import type { RestangularService } from '../common/restangular.service'

import { app } from '../../app.module'

/**
 * メール通知設定
 */
class NotifySetting {
  // メモの通知設定
  private notifyList: {
    groupId: number
    notifyMemo: number
  }[]
  private notifyMemo: number
  private groups: {
    groupId: number
    groupName: string
  }[]
  private groupId: number
  private userId: number

  constructor(
    $rootScope,
    private DialogService,
    private RestangularService: RestangularService
  ) {
    this.groupId = $rootScope.groupId
  }

  /**
   * 初期化
   */
  public $onInit() {
    this.setNotify()
    this.setGroupList()
  }

  /**
   * グループ切り替えると、通知設定情報をセット
   */
  public changeGroup() {
    this.setNotifyByGroup()
  }

  /**
   * メモの通知設定を変更
   */
  public changeNotify() {
    const endpoint = '/users/notify'
    const params = {
      userId: this.userId,
      groupId: this.groupId,
      notify: this.notifyMemo,
    }

    // 対象ユーザーのメモの通知設定を更新
    this.RestangularService.request('UPDATE', endpoint, params)
      .then(() => {
        this.notifyList.filter((notify) => {
          return Number(notify.groupId) === Number(this.groupId)
        })[0].notifyMemo = this.notifyMemo

        this.DialogService.showToast('通知設定を保存しました。', 'success-toast')
      })
      .catch(() => {
        this.DialogService.showToast('通知設定の保存に失敗しました。', 'error-toast')
      })
  }

  /**
   * 対象ユーザーのメモの通知設定情報をセット
   */
  private setNotify() {
    const endpoint = '/users/notify'
    const params = {
      userId: this.userId,
    }

    // 対象ユーザーのグループ一覧を取得
    this.RestangularService.request('GET', endpoint, params).then((result) => {
      this.notifyList = result[0].data

      this.setNotifyByGroup()
    })
  }

  /**
   * 選択しているグループの通知設定情報をセット
   */
  private setNotifyByGroup() {
    const notify = this.notifyList.filter((notify) => {
      return Number(notify.groupId) === Number(this.groupId)
    })

    this.notifyMemo = notify[0].notifyMemo
  }

  /**
   * 対象ユーザーのグループ一覧をセット
   */
  private setGroupList() {
    const endpoint = '/users/groups'
    const params = {
      userId: this.userId,
    }

    // 対象ユーザーのグループ一覧を取得
    this.RestangularService.request('GET', endpoint, params).then((result) => {
      this.groups = result[0].data
    })
  }
}

app.component('notifySetting', {
  bindings: {
    userId: '=',
  },
  template: require('./notify-setting.pug')(),
  controller: NotifySetting,
})
